import React, {
  Fragment,
  useState,
  useContext,
  createContext,
  useCallback,
} from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import { Provider, } from 'react-reqq-lite';
import store from '../../../store';
import history from '../../../history';
// import { XIcon, MinusIcon } from '@heroicons/react/outline';

const SIZE = {
  xs: 'max-w-sm',
  sm: 'max-w-lg',
  default: 'max-w-2xl',
  lg: 'max-w-4xl',
  xl: 'max-w-6xl',
  full: 'w-full',
};
const DrawerModal = ({ options, onClose }) => {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    setOpen(true);
  }, [setOpen]);
  const handleClose = () => {
    setOpen(false);
  };
  const sizeClassName = React.useMemo(
    () => SIZE[options.size] || SIZE.default,
    [options]
  );
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        open
        className={cn(
          'fixed inset-0 overflow-hidden',
          options?.zIndex || 'modal-right'
        )}
        onClose={() => {
          if (options.closeOutside) handleClose();
        }}
      >
        <div className="absolute inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={onClose}
          >
            <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-y-0 right-0 max-w-full flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className={cn('relative w-screen', sizeClassName)}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-500"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="d-flex mb-3 mt-5">
                    <button
                      onClick={handleClose}
                      type="button"
                      className="btn btn-link ml-auto"
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                  {/* <div className="absolute top-2 right-3 flex z-10">
                    <button
                      className={cn(
                        'rounded-full text-gray-600 hover:text-gray-900 focus:outline-none hover:ring-2 hover:ring-gray-600 bg-white transition p-3',
                        {
                          'opacity-0 pointer-events-none': !options.closeButton,
                        }
                      )}
                      onClick={handleClose}
                      type="button"
                    >
                      <span className="sr-only">Close</span>
                      <i className="h-6 w-6 fas fa-times" />
                    </button>
                  </div> */}
                </Transition.Child>
                <div className="h-full flex flex-col py-6 bg-white overflow-y-auto">
                  {options.title && (
                    <div className="px-4 sm:px-6">
                      <Dialog.Title className="text-lg font-medium text-gray-900">
                        {options.title}
                      </Dialog.Title>
                    </div>
                  )}
                  <div className="mt-6 relative flex-1 px-4 sm:px-6">
                    {options.content(handleClose)}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
DrawerModal.propTypes = {
  options: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};
export const showDrawer = (options) => {
  const opt = {
    content: 'Modal Content',
    closeButton: true,
    closeOutside: false,
    onClose: () => { },
    size: 'default',
    title: '',
    // zIndex: '', optional props
    ...options,
  };
  const root = document.getElementById('drawer-root');
  const handleClose = () => {
    opt.onClose();
    render(<DrawerMarker />, root);
  };
  if (!root) {
    alert('Modal root not found!'); // eslint-disable-line
    return;
  }
  render(
    <Provider store={store}>
      <BrowserRouter history={history}>
        <DrawerModal options={opt} onClose={handleClose} />
      </BrowserRouter>
    </Provider>,
    root
  );
};
export const DrawerMarker = () => {
  return <div id="drawer-root" />;
};
const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modals, setModals] = useState([]);
  const [states, setStates] = useState({});
  return (
    <ModalContext.Provider value={{ setModals, modals, states, setStates }}>
      <DrawerMarker />
      {children}
    </ModalContext.Provider>
  );
}
ModalProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
export const useDestroyModal = () => {
  const { setModals, setStates } = useContext(ModalContext);
  const destroyModal = useCallback(() => {
    setModals([]);
    setStates({});
  }, [setModals, setStates]);
  return destroyModal;
};